export default {"src":"https://cdn.sa-tech.de/homeone/main/_next/static/media/SvgArrowDown.ab71e82b.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};